import { observer } from 'mobx-react-lite'
import { Crown } from 'iconoir-react'
import Button from 'app/components/Button'
import FloatingSave from 'app/components/FloatingSave'
import FormInput from 'app/components/form/FormInput'
import FormPanel from 'app/components/form/FormPanel'
import { SmartForm } from 'app/components/form/SmartForm'
import { formatPhoneNumber } from 'app/formatPhoneNumber'
import { UserJson } from 'app/types/entities'
import { profileValidator } from './profileValidator'
import type { UseUserProfileReturn } from './useUserProfile'

export type UserProfileComponentProps = UseUserProfileReturn

export const UserProfileComponent = observer(function UserProfileComponent(props: UserProfileComponentProps) {
  const {
    user,
    isSuperUser,
    isDirtyForm,
    setIsDirtyForm,
    isImpersonating,
    impersonateUserHandler,
    resetPasswordHandler,
    onSave,
  } = props

  return (
    <SmartForm
      validator={profileValidator}
      method="post"
      className="!mt-0 gap-y-8"
      hideButtons
      preventSubmit
      onSubmit={(data) => {
        if (!data) return
        const { id, ...input } = data
        onSave(input)
      }}
    >
      <input type="hidden" name="id" value={user.id} />

      <FormPanel title="Profile Details" cols={6}>
        <div className="flex flex-col gap-4">
          <FormInput
            name="name"
            label="Name"
            required
            labelClassName="text-ui-sm font-semibold text-strong"
            className="text-body-sm text-strong shadow-elevation-1"
            defaultValue={user.name}
            onChange={() => setIsDirtyForm(true)}
          />
          <FormInput
            name="email"
            label="Email"
            type="email"
            required
            labelClassName="text-ui-sm font-semibold text-strong"
            className="text-body-sm text-strong shadow-elevation-1"
            defaultValue={user.email}
            onChange={() => setIsDirtyForm(true)}
          />
          <FormInput
            name="phone"
            label="Phone Number"
            labelClassName="text-ui-sm font-semibold text-strong"
            className="text-body-sm text-strong shadow-elevation-1"
            defaultValue={formatPhoneNumber((user as UserJson & { phone?: string }).phone ?? ``)}
            onChange={() => setIsDirtyForm(true)}
          />
        </div>
      </FormPanel>

      <FormPanel title="Manage Access" cols={6}>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={resetPasswordHandler}
            className="rounded-md border border-blue-600 bg-surface px-4 py-[9px] text-label-xs text-blue-600 shadow-elevation-1 hover:bg-blue-50"
          >
            Reset Password
          </button>
          {isSuperUser && (
            <Button
              mode="tertiary"
              size="md"
              onClick={impersonateUserHandler}
              loading={isImpersonating}
              className="border-(--control-border) text-default"
            >
              Impersonate User
              <div className="size-5 flex items-center justify-center rounded bg-amber-500/[0.08]">
                <Crown width={12} height={12} className="text-amber-800" />
              </div>
            </Button>
          )}
        </div>
      </FormPanel>

      <FloatingSave isDirtyForm={isDirtyForm} />
    </SmartForm>
  )
})
